import { Reducer, UnknownAction } from "redux";

// LocalSlice is used for slices that not get published to the server.
export class LocalSlice<StateType> {
  reducer: Reducer<StateType, UnknownAction>;

  constructor({ reducer }: { reducer: Reducer<StateType, UnknownAction> }) {
    this.reducer = reducer;
  }
}
